<template>
  <div v-if="menu.Categories">
    <div v-if="menu.Categories.length > 0">
      <section :id="'section-search'">
        <div class="row search-product">
          <div class="search-box col-12">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input
              type="text"
              v-model="filterText"
              class="form-input"
              :placeholder="getSearchProductsPlaceholder"
            />
          </div>
        </div>
      </section>
      <section
        v-for="category in menu.Categories"
        :key="category.ID"
        :id="'section-' + category.ID"
      >
        <div class="row" v-if="porductToShow(category).length > 0">
          <div class="col-sm-12 category-title">
            <h2 id="combos">{{ category.Name | camelCase }}</h2>
            <div v-html="category.Description"></div>
          </div>
        </div>
        <div class="row menu-content">
          <div
            v-for="product in porductToShow(category)"
            :key="product.ID"
            class="col-sm-12 col-md-12"
            :class="productClass"
          >
            <Product
              :product="menu.Products[product.ProductID]"
              :modifiers="menu.ModifierGroups"
              :category="product"
              :key="product.ID"
              :sectionId="category.ID"
              :parent-category="category"
            />
          </div>
        </div>
      </section>
      <div v-if="getcountproduct == 0">{{ $t('message.Nomatchingproducts') }}</div>


    </div>
    <div v-else>
      <message />
    </div>
    <confirmationModal></confirmationModal>
  </div>

</template>

<script>
import Product from "./Product";
import Message from "../../shared/Message";
import { $$ } from "./../../../sharedscripts/OO_jquery";
import { mapGetters } from "vuex";
import confirmationModal from "../../confirmationModal.vue";
export default {
  name: "ProductList",
  components: { Product, Message, confirmationModal },
  props: {
    menu: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      productClass: "col-xl-6",
      once: true,
      filterText: null
    };
  },
  updated() {
    if (this.isWC()) {
      this.calcProductClass();
      if (this.once) {
        window.addEventListener("resize", this.calcProductClass);
        this.once = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getDietarySelection"]),
    getSearchProductsPlaceholder(){
      return this.$t("message.SearchProducts")
    },
    getcountproduct(){
      var count = 0;
      if(this.menu.Categories && this.menu.Categories.length > 0)
      {
        this.menu.Categories.forEach(element => {
          if(element && element.SubMenuItems)
          {
              var items = this.porductToShow(element);
                  count += items.length;
          }
        });
        
      }
      return count;
    },
  },
  methods: {
    calcProductClass() {
      var containerWidth = $$(".oo-module").outerWidth();
      if (containerWidth > 992) {
        this.productClass = "col-xl-6";
      } else {
        this.productClass = "col-xl-12";
      }
      this.$emit("update-containerWidth", containerWidth);
    },
    porductToShow(category) {
      var items = category.SubMenuItems.filter(
        p =>
          !this.filterText ||
          p.Name.toUpperCase().indexOf(this.filterText.toUpperCase()) > -1
      );
      if (this.getDietarySelection.Allergy.length > 0) {
        items = items.filter(
          p =>
            this.getDietarySelection.Allergy.filter(a1 =>
              p.ProductAllergy.some(a2 => a2 == a1.Id)
            ).length == this.getDietarySelection.Allergy.length
        );
      }
      if (this.getDietarySelection.Intolerance.length > 0) {
        items = items.filter(
          p =>
            this.getDietarySelection.Intolerance.filter(a1 =>
              p.ProductIntolerance.some(a2 => a2 == a1.Id)
            ).length == this.getDietarySelection.Intolerance.length
        );
      }
      if (this.getDietarySelection.Preference.length > 0) {
        items = items.filter(
          p =>
            this.getDietarySelection.Preference.filter(a1 =>
              p.ProductPreference.some(a2 => a2 == a1.Id)
            ).length == this.getDietarySelection.Preference.length
        );
      }
      return items;
    }
  }
};
</script>
